import styled from 'styled-components';

import { body } from '@constants/fonts';

export const LineItem = styled.div`
  padding: 10px 40px 10px 40px;
  position: relative;
  transition: background-color 0.2s;
  font-family: ${body};
  cursor: pointer;
  color: ${({ theme }) => theme.palette.text.primary};
  min-height: 23px;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 600;
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: 9px;
  left: 0px;
  width: 20px;
  height: 20px;
  font-size: 20px;
`;
